var _excluded = ["UNSAFE_className"],
  _excluded2 = ["defaultSelectedKey", "disabledKeys", "selectedKey", "ref"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { ComboBox as SpectrumComboBox } from '@adobe/react-spectrum';
import cl from 'classnames';
import { useMergeRef } from '@deephaven/react-hooks';
import { usePickerProps } from "../picker/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
export { SpectrumComboBox };
export var ComboBox = /*#__PURE__*/React.forwardRef(function ComboBox(_ref, ref) {
  var UNSAFE_className = _ref.UNSAFE_className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _usePickerProps = usePickerProps(props),
    defaultSelectedKey = _usePickerProps.defaultSelectedKey,
    disabledKeys = _usePickerProps.disabledKeys,
    selectedKey = _usePickerProps.selectedKey,
    scrollRef = _usePickerProps.ref,
    comboBoxProps = _objectWithoutProperties(_usePickerProps, _excluded2);
  var pickerRef = useMergeRef(ref, scrollRef);
  return /*#__PURE__*/_jsx(SpectrumComboBox
  // eslint-disable-next-line react/jsx-props-no-spreading
  , _objectSpread(_objectSpread({}, comboBoxProps), {}, {
    UNSAFE_className: cl('dh-combobox', UNSAFE_className),
    ref: pickerRef
    // Type assertions are necessary here since Spectrum types don't account
    // for number and boolean key values even though they are valid runtime
    // values.
    ,
    defaultSelectedKey: defaultSelectedKey,
    disabledKeys: disabledKeys,
    selectedKey: selectedKey
  }));
});
ComboBox.displayName = 'ComboBox';
//# sourceMappingURL=ComboBox.js.map